import { Trans } from '@lingui/macro';
import { TFCard, TFText } from '@tf/ui';
import type React from 'react';

export const FormLoadingCard: React.FC = () => {
	return (
		<TFCard w="50rem" maw="50rem" innerPadding="1.5rem">
			<TFText>
				<Trans id="formLoadingCard.loading">Loading...</Trans>
			</TFText>
		</TFCard>
	);
};
